import { TaskTimeOptions, UseTypeOptions } from './task-template-modal-dialog.config';
import { AfterContentInit, AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { autoUnsubscribeMixin } from '@core/helpers/auto-unsubscribe.mixin';
import {
  TaskTemplateModalDialogStateService
} from '@shared/components/task-template-modal-dialog/task-template-modal-dialog.state.service';
import { CustomSnackbarService } from '@core/services/custom-snackbar.service';
import {
  TaskTriggerTypeOptions,
  PriorityOptions,
  TypeOptions,
  DueDateType
} from '@shared/components/task-template-modal-dialog/task-template-modal-dialog.config';
import { TaskTemplate } from '@shared/models/task-template';
import { CreateTaskTemplateCommand } from '@shared/models/requests/create-task-template.command';
import { AttachmentModel, SearchMemberOptionsModel, SearchUserOptionsModel } from '@shared/models';
import { EmailTemplateDto } from '@core/services/dto';
import { STATUS_ACTIVE_INACTIVE_OPTIONS } from '@shared/constants/select-options.constants';
import { FileTypeEnum, TaskTemplatePriorityEnum, TaskTypeEnum } from '@shared/enums';
import { CreateConversationStateService } from '../conversation/create-conversation.state.service';
import { GLOBAL_SETTINGS } from '@shared/constants/global-settings';
import { Observable, Subject } from 'rxjs';
import { AssigneeFormControl } from '@shared/controls/assignee-form-control';
import { GlobalStateService } from '@core/services/global.state.service';
import { CreateTaskStateService } from '../create-task/create-task.state.service';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { SMSTemplateDto } from '@core/services/dto/sms-template.dto';
import { resolveTaskTemplateAssigneeId } from './task-template-assignee';

@Component({
  selector: 'app-task-template-modal-dialog',
  templateUrl: './task-template-modal-dialog.component.html',
  styleUrls: ['./task-template-modal-dialog.component.scss']
})
export class TaskTemplateModalDialogComponent extends autoUnsubscribeMixin() implements OnInit, AfterContentInit {
  form: FormGroup;
  isDisabled = false;
  showTimeField = false;
  statusOptions = STATUS_ACTIVE_INACTIVE_OPTIONS;
  typeOptions = TypeOptions;
  priorityOptions = PriorityOptions;
  useTypeOptions = UseTypeOptions;
  dueDateType = DueDateType;
  taskTriggerTypeOptions = TaskTriggerTypeOptions;
  timeOptions = TaskTimeOptions;
  emailTemplates: number[] = [];
  smsTemplates: number[] = [];
  taskTemplate: TaskTemplate;
  files: AttachmentModel[];
  isEditMode = false;
  preselectedEmailTemplates: EmailTemplateDto[] = [];
  preselectedSmsTemplates: SMSTemplateDto[] = [];
  FileTypeEnum = FileTypeEnum;
  GLOBAL_SETTINGS = GLOBAL_SETTINGS;
  conversationUsers$!: Observable<any>;
  selectedUser: any;
  dataCome: any;
  public isEdit = true;
  assignedId: any;
  ischanged = false;
  defaultAssigneeUserName = new Subject<SearchUserOptionsModel>();
  defaultUser: any;
  @ViewChild(MatAutocompleteTrigger) autocompleteTrigger: MatAutocompleteTrigger;

  @Output() closeDialog = new EventEmitter<{ changesMade: boolean }>();
  @Input() Id?;

  constructor(
    private fb: FormBuilder,
    private state: TaskTemplateModalDialogStateService,
    private toast: CustomSnackbarService,
    private service: CreateTaskStateService,
    private globalState: GlobalStateService

  ) {
    super();
    this.conversationUsers$ = this.service.users$();
    this.selectedUser = null;
    // this.form = this.fb.group({
    //   name: ['', [Validators.maxLength(50), Validators.required]],
    //   status: ['', Validators.required],
    //   type: [TaskTypeEnum[TaskTypeEnum.General], Validators.required],
    //   useType: [null, Validators.required],
    //   priority: [TaskTemplatePriorityEnum[TaskTemplatePriorityEnum.High], Validators.required],
    //   description: ['', [Validators.maxLength(1000), Validators.minLength(3), Validators.required]],
    //   taskTriggerType: ['Manual'],
    //   allowManualExecution: [false],
    //   dueIn: [null, Validators.max(99)],
    //   dueDateType: [''],
    //   triggerTime: [],
    //   assigneeId: ['']
    // });

    this.form = this.fb.group({
      name: ['', [Validators.maxLength(50), Validators.required]],
      status: ['', Validators.required],
      type: [TaskTypeEnum[TaskTypeEnum.General], Validators.required],
      useType: [null, Validators.required],
      priority: [TaskTemplatePriorityEnum[TaskTemplatePriorityEnum.High], Validators.required],
      description: ['', [Validators.maxLength(1000), Validators.minLength(3), Validators.required]],

      taskTriggerType: ['Manual'],
      allowManualExecution: [false],
      // triggerTime: [null],

      dueIn: [null, Validators.max(99)],
      dueDateType: [''],
      dueDateTime: [null],

      showTasks: [false],

      assigneeId: ['']
    });
  }

  ngOnInit(): void {
    this.form.get('assigneeId').valueChanges.subscribe(name => {
      if (!name) {
        return;
      }

      if ((name?.length >= GLOBAL_SETTINGS.minLengthToTriggerSearch)) {
        this.service.getTaskListSearchedUserGroups(name);
      }
    });
    if (this.Id) {
      this.isEditMode = true;
      this.state.getTaskTemplate(this.Id).subscribe(task => {
        let fullName;
        if (task.assigneeId?.isGroup) {
          fullName = task.assigneeId?.name;
          this.assignedId = task.assigneeId?.id;
        } else if (task.assigneeId?.isGroup === false) {
          fullName = `${task.assigneeId?.firstName} ${task.assigneeId?.lastName}`;
          this.assignedId = task.assigneeId?.id;
        }
        else {
          fullName = null;
          this.assignedId = null;
        }
        this.files = task.attachments;
        this.taskTemplate = task;
        // this.form = this.fb.group({
        //   name: this.taskTemplate.name,
        //   status: this.taskTemplate.status,
        //   type: this.taskTemplate.type,
        //   useType: this.taskTemplate.useType,
        //   priority: this.taskTemplate.priority,
        //   description: this.taskTemplate.description,
        //   dueIn: this.taskTemplate.timeDue.dueIn,
        //   dueDateType: this.taskTemplate.timeDue.dueDateType,
        //   assigneeId: fullName
        // });

        this.form = this.fb.group({
          name: [this.taskTemplate.name, [Validators.maxLength(50), Validators.required]],
          status: [this.taskTemplate.status, Validators.required],
          type: [this.taskTemplate.type, Validators.required],
          useType: [this.taskTemplate.useType, Validators.required],
          priority: [this.taskTemplate.priority, Validators.required],
          description: [this.taskTemplate.description, [Validators.maxLength(1000), Validators.minLength(3), Validators.required]],

          taskTriggerType: [this.taskTemplate.taskTriggerType || 'Manual'],
          allowManualExecution: [this.taskTemplate.allowManualExecution || false],
          // triggerTime: [this.taskTemplate.triggerTime ?? null],
          dueDateTime: [this.taskTemplate.timeDue?.dueDateTime ?? null],

          dueIn: [this.taskTemplate.timeDue?.dueIn ?? null, Validators.max(99)],
          dueDateType: [this.taskTemplate.timeDue?.dueDateType ?? ''],

          showTasks: [this.taskTemplate.showTasks ?? false],

          assigneeId: [fullName]
        });
        this.selectedUser = { ...task, name: fullName };

        if (task.emails?.length) {
          this.state.getEmailTemplates(task.emails).subscribe(response => {
            this.preselectedEmailTemplates = response.data;
          });
        }
        if (task.sms?.length) {
          this.state.getSmsTemplates(task.sms).subscribe(response => {
            this.preselectedSmsTemplates = response.data;
          });
        }

        this.bindDueInValidation();
      });
    } else {
      this.bindDueInValidation();
    }
    this.isEdit = false;
    this.conversationUsers$.subscribe(v => console.log('conversationUsers$', v));

  }

  bindDueInValidation(): void {
    this.form.get('taskTriggerType')?.valueChanges.subscribe(() => this.onTaskTriggerTypeChange());
    this.form.get('dueIn')?.valueChanges.subscribe(() => this.updateDueIn());

    this.onTaskTriggerTypeChange();
    this.updateDueIn();
  }

  ngAfterContentInit(): any {
    if (this.autocompleteTrigger && this.autocompleteTrigger.panelOpen) {
      this.autocompleteTrigger.closePanel();
    } else if (this.autocompleteTrigger) {
      this.autocompleteTrigger.openPanel();
    }
  }

  onchangemat(): any {
    this.isEdit = true;
    this.form.get('assigneeId').valueChanges.subscribe(name => {
      if (!name) {
        return;
      }
      if ((name?.length >= GLOBAL_SETTINGS.minLengthToTriggerSearch)) {
        this.service.getSearchedUserGroups(name);
      }
      this.ischanged = true;
    });
  }

  disableForm(event: boolean): void {
    this.isDisabled = event;
  }

  record(): void {

    const formValue = this.form.value;
    const assignee = this.form.get('assigneeId')?.value;

    this.taskTemplate = {
      ...formValue,
      taskTriggerType: formValue.taskTriggerType,
      allowManualExecution: formValue.allowManualExecution,
      // triggerTime: formValue.triggerTime,
      showTasks: formValue.showTasks,
      attachments: formValue.attachments?.map((x: any) => x.id) ?? []
    };

    (this.taskTemplate as unknown as CreateTaskTemplateCommand).assigneeId = resolveTaskTemplateAssigneeId(assignee, this.assignedId);

    // Due configuration
    if (formValue.dueIn && formValue.dueDateType) {
      this.taskTemplate.timeDue = {
        dueIn: formValue.dueIn,
        dueDateType: formValue.dueDateType,
        dueDateTime: formValue.dueDateTime
      };
    }

    // Email / SMS templates
    this.taskTemplate.emails = this.isEmailType() ? this.emailTemplates : [];
    this.taskTemplate.sms = this.isSMSType() ? this.smsTemplates : [];

    // Save / Update
    if (this.Id) {
      this.state.updateTaskTemplate(this.Id, this.taskTemplate).subscribe(data => {
        this.showToast(data);
      });
    } else {
      this.state.createTaskTemplate(this.taskTemplate).subscribe(data => {
        this.showToast(data);
      });
    }
  }

  showToast(data?): void {
    if ('id' in data) {
      this.toast.success('Template successfully saved');
      this.closeDialog.emit({ changesMade: true });
    }
  }

  updateDueIn(): void {
    const dueIn = this.form.get('dueIn')?.value;
    const dueDateType = this.form.get('dueDateType');

    if (dueIn) {
      dueDateType.setValidators(Validators.required);
    } else {
      dueDateType.clearValidators();
    }

    dueDateType.updateValueAndValidity();

    this.updateTimeVisibility();
  }

  updateTimeVisibility(): void {
    const triggerType = this.form.get('taskTriggerType')?.value;
    const dueIn = this.form.get('dueIn')?.value;

    this.showTimeField = triggerType === 'Automatic' && !!dueIn;
    const dueDateTimeControl = this.form.get('dueDateTime');

    if (this.showTimeField) {
      // Default to 9 AM
      if (dueDateTimeControl && dueDateTimeControl.value === null) {
        dueDateTimeControl.setValue(9);
      }
    } else {
      dueDateTimeControl?.reset();
    }
  }

  addEmail(selectedIds): void {
    this.emailTemplates = selectedIds;
  }

  isEmailType(): boolean {
    return this.form.controls.type.value === 'Email';
  }

  isSMSType(): boolean {
    return this.form.controls.type.value === 'SMS';
  }

  addSMS(selectedIds): void {
    this.smsTemplates = selectedIds;
  }

  getOptionText(option): any {
    if (!option) {
      return '';
    }

    if (typeof option === 'string') {
      return option;
    }

    return option?.label || option?.name || `${option?.firstName ?? ''} ${option?.lastName ?? ''}`.trim();
  }

  onTaskTriggerTypeChange(): void {
    const triggerType = this.form.get('taskTriggerType')?.value;
    const dueIn = this.form.get('dueIn');

    if (triggerType === 'Automatic') {
      dueIn?.setValidators([Validators.required, Validators.max(99)]);
    } else {
      dueIn?.setValidators(Validators.max(99));
    }

    dueIn?.updateValueAndValidity();

    if (triggerType !== 'Automatic') {
      this.form.get('allowManualExecution')?.setValue(false);
    }

    this.updateTimeVisibility();
  }

}
